import dynamic from "next/dynamic";

import { getPostBySlug } from "../services/markdown-apis/apiMarkdown";
import markdownToHtml from "../services/markdown-apis/markdownToHtml";

const PrivacyPolicy = dynamic(() => import("../containers/PrivacyPolicy"));

export default function PrivacyPolicyPage({ post }) {
  return (
    <>
      <PrivacyPolicy content={post} />
    </>
  );
}

export async function getStaticProps({ params }) {
  const slug = "privacy_policy";
  const post = getPostBySlug(slug, ["content"]);
  const content = await markdownToHtml(post.content || "");

  return {
    props: {
      post: {
        ...post,
        content,
      },
    },
  };
}
